module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner affairEdit"
  }, [_c('div', {
    staticClass: "headBar"
  }, [_vm._v("专业委员会")]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "scroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    ref: "tabNavs",
    staticClass: "tabNavs"
  }, [_vm._l((_vm.navs), function(item, index) {
    return _c('div', {
      key: index,
      class: ['tabItem', {
        'act': _vm.navAct === index
      }],
      on: {
        "click": function($event) {
          _vm.tabChange($event, index)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item) + "\n                ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "moveLine",
    style: (_vm.lineStr)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tabContent"
  }, [_c('Subpage1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navAct === 0),
      expression: "navAct===0"
    }],
    ref: "Subpage1",
    attrs: {
      "indata": _vm.param.dto
    }
  }), _vm._v(" "), _c('Subpage2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navAct === 1),
      expression: "navAct===1"
    }],
    ref: "Subpage2",
    attrs: {
      "indata": _vm.param.dto
    }
  }), _vm._v(" "), _c('Subpage3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.param.dto.type == 2 && _vm.navAct === 2),
      expression: "param.dto.type==2&&navAct===2"
    }],
    ref: "Subpage3",
    attrs: {
      "indata": _vm.param.dto
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "pagefoot"
  }, [(_vm.pgState) ? _c('div', {
    staticClass: "loading"
  }, [(_vm.pgState == 1) ? _c('span', [_vm._v("初始化中...")]) : _vm._e(), _vm._v(" "), (_vm.pgState == 2) ? _c('span', [_vm._v("数据保存中...")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('div', [_c('el-button', {
    attrs: {
      "disabled": _vm.loading,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.goSave()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goReturn
    }
  }, [_vm._v("返回")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-8201438e"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/cms/user/professional_committee/add/index.vue
// module id = 1536
// module chunks = 1